import { render, staticRenderFns } from "./AdminDashboardWidgets.vue?vue&type=template&id=05f1aca6"
import script from "./AdminDashboardWidgets.vue?vue&type=script&lang=js"
export * from "./AdminDashboardWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports